module.exports = __webpack_public_path__ + "static/media/se_page11.02663aa2.ogg";